import { render, staticRenderFns } from "./CenterNavigation.vue?vue&type=template&id=483d1e3e&scoped=true&"
import script from "./CenterNavigation.vue?vue&type=script&lang=js&"
export * from "./CenterNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CenterNavigation.vue?vue&type=style&index=0&id=483d1e3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483d1e3e",
  null
  
)

export default component.exports